{
  "CHAT_LIST": {
    "LOADING": "Λήψη συζητήσεων",
    "LOAD_MORE_CONVERSATIONS": "Φόρτωση περισσότερων συζητήσεων",
    "EOF": "Όλες οι συζητήσεις φορτώθηκαν 🎉",
    "LIST": {
      "404": "Δεν υπάρχουν ενεργές συζητήσεις σε αυτήν την ομάδα."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "Συζητήσεις",
    "MENTION_HEADING": "Αναφορές",
    "UNATTENDED_HEADING": "Χωρίς Παρακολούθηση",
    "SEARCH": {
      "INPUT": "Αναζήτηση Ανθρώπων, συνομιλιών, αποθηκευμένων απαντήσεων .."
    },
    "SEARCH_MESSAGES": "Αναζήτηση συνομιλιών",
    "SEARCH_INPUT_PLACEHOLDER": "Αναζήτηση συνομιλιών...",
    "FILTER_ALL": "Όλες",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Δικές μου",
      "unassigned": "Χωρίς Αντιστοίχιση",
      "all": "Όλες"
    },
    "MESSAGE_USE_AS_TEMPLATE": "Επικόλληση στην απάντηση",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "Άνοιγμα",
        "BUY": "Αγορά"
      }
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Ανοιχτές"
      },
      "resolved": {
        "TEXT": "Επιλύθηκαν"
      },
      "pending": {
        "TEXT": "Εκκρεμεί"
      },
      "snoozed": {
        "TEXT": "Αναβολή"
      },
      "all": {
        "TEXT": "Όλες"
      }
    },
    "VIEW_FILTER": "Προβολή",
    "SORT_TOOLTIP_LABEL": "Sort conversations",
    "CHAT_SORT": {
      "STATUS": "Κατάσταση",
      "ORDER_BY": "Order by"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "Created",
      "LAST_ACTIVITY": "Last activity:",
      "LAST_CUSTOMER_MESSAGE": "Τελευταίο μήνυμα πελάτη:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Last activity: Oldest first"
      },
      "last_activity_at_desc": {
        "TEXT": "Last activity: Newest first"
      },
      "last_customer_message_at_asc": {
        "TEXT": "Τελευταίο μήνυμα πελάτη: Παλαιότερα πρώτα"
      },
      "last_customer_message_at_desc": {
        "TEXT": "Τελευταίο μήνυμα πελάτη: Νεότερα πρώτα"
      },
      "created_at_desc": {
        "TEXT": "Created at: Newest first"
      },
      "created_at_asc": {
        "TEXT": "Created at: Oldest first"
      },
      "priority_desc": {
        "TEXT": "Priority: Highest first"
      },
      "priority_asc": {
        "TEXT": "Priority: Lowest first"
      },
      "priority_created_at_desc": {
        "TEXT": "Προτεραιότητα + Ημερομηνία δημιουργίας: Νεότερα πρώτα"
      },
      "priority_created_at_asc": {
        "TEXT": "Προτεραιότητα + Ημερομηνία δημιουργίας: Παλαιότερα πρώτα"
      },
      "waiting_since_asc": {
        "TEXT": "Pending Response: Longest first"
      },
      "waiting_since_desc": {
        "TEXT": "Pending Response: Shortest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Μήνυμα εικόνας"
      },
      "audio": {
        "CONTENT": "Μήνυμα ήχου"
      },
      "video": {
        "CONTENT": "Μήνυμα βίντεο"
      },
      "file": {
        "CONTENT": "Επισυναπτόμενο αρχείο"
      },
      "location": {
        "CONTENT": "Θέση"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "έχει μοιράσει ένα σύνδεσμο"
      },
      "contact": {
        "CONTENT": "Shared contact"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Sort conversation",
      "DROPDOWN_TITLE": "Ταξινόμηση κατά",
      "ITEMS": {
        "LATEST": {
          "NAME": "Last activity at",
          "LABEL": "Last activity"
        },
        "CREATED_AT": {
          "NAME": "Δημιουργήθηκε στις",
          "LABEL": "Δημιουργήθηκε στις"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Last user message at",
          "LABEL": "Last message"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Παραλήφθηκε από email",
    "VIEW_TWEET_IN_TWITTER": "Προβολή του tweet στο Twitter",
    "REPLY_TO_TWEET": "Απάντηση στο tweet",
    "LINK_TO_STORY": "Μετάβαση στην ιστορία instagram",
    "SENT": "Επιτυχής αποστολή",
    "READ": "Διαβάστηκε με επιτυχία",
    "DELIVERED": "Παραδόθηκε με επιτυχία",
    "NO_MESSAGES": "Κανένα Μήνυμα",
    "NO_CONTENT": "Μη διαθέσιμο περιεχόμενο",
    "HIDE_QUOTED_TEXT": "Απόκρυψη Κειμένου Παράθεσης",
    "SHOW_QUOTED_TEXT": "Απόκρυψη Κειμένου Παράθεσης",
    "HIDE_AUTOMATED_MESSAGE": "Απόκρυψη Περιεχομένου Αυτόματης Απάντησης",
    "SHOW_AUTOMATED_MESSAGE": "Εμφάνιση Περιεχομένου Αυτόματης Απάντησης",
    "AUTOMATED_MESSAGE": "Αυτόματη Απάντηση",
    "MESSAGE_READ": "Ανάγνωση",
    "SENDING": "Sending"
  }
}
